module.exports = __webpack_public_path__ + "static/media/lc.1c3a5554.svg";